<template>
    <div class="card">
        <div>
          <div class="row">
            <div :class="hasGlobalMachineImage ? 'col-md-9' : 'col-md-12'">
            <table class="table custom-table-padding">
                <thead>			
                    <tr>
                        <th class="name-th">Test</th>
                        <th class="machine-th">Machine Data</th>
                        <th class="result-th">Final Result</th>
                        <th v-if="hasUnitColumn">Unit</th>
                        <th v-if="hasInterpretationColumn">Reference</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="item in tableItems.filter(
                          item => item.investigation_report_type != 'machine_image'
                        )" :key="item.id">
                        <td>
                            {{ item.name }}
                        </td>
                        <td>
                            <textarea
                                rows="1"
                                class="form-control"
                                readonly
                                v-model="item.machine_result"
                            ></textarea>
                        </td>
                        <td>
                            <div v-if="item.investigation_report_type === 'general_text'" class="form-control">
                              <AsyncSelect
                                  placeholder="Select"
                                  v-model="item.cs_growth"
                                  :api-service="fetchNoteMasterList"
                                  :additional-query="{note_type: item.note_master_type}"
                                  label="name"
                                  :reduce="option => option"
                                  class="mb-1"
                                  @update:modelValue="handleGrowthChange(item)"
                              />
                                <TipTapEditor
                                    v-model:content="item.result"
                                />
                            </div>
                            <v-select
                                v-else-if="item.investigation_report_type === 'antibiotics'"
                                class="form-control p-0"
                                v-model="item.result"
                                :options="antibioticsDrowdown"
                                label="name"
                                placeholder="Select antibiotic"
                                :reduce="name => name.id"
                            />
                          <AsyncSelect
                              placeholder="Select Result"
                              v-else-if="item.is_result_dropdown === 1"
                              v-model="item.result"
                              :api-service="fetchNoteMasterList"
                              :additional-query="{note_type: 'investigation_result_drop_down'}"
                              label="name"
                              :reduce="name => name.name"
                          />
                            <div v-else>
                                <textarea
                                    rows="1" class="form-control"
                                    placeholder="Enter result"
                                    v-model="item.result"
                                ></textarea>
                            </div>
                        </td>
                        <td v-if="hasUnitColumn">
                            {{ item.unit }}
                        </td>
                        <td v-if="hasInterpretationColumn">
                          <template v-if="item.investigation_report_type === 'antibiotics'">
                            <input type="text"
                                   class="form-control"
                                   v-model="item.comment"
                                   placeholder="Interpretation / Comment"
                            >
                          </template>

                          <template v-else>
                            {{ item.reference_value }}
                          </template>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
            <div v-if="hasMachineImage" class="col-md-3 border-start">
              <div
                  v-for="item in tableItems.filter(
                          item => item.investigation_report_type == 'machine_image'
                   )"
                  :key="item.id"
                  class="mb-3 text-center"
              >
                <img
                    v-if="item.result"
                    :src="getBase64ImageDataUri(item.result)"
                    style="max-width: 200px; max-height: 200px; margin-top: 10px;"
                />
              </div>
            </div>
          </div>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
import TipTapEditor from '@/components/atom/TipTapEditor';
import {computed, ref, watch} from "vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleHospital from '@/services/modules/hospital';
import { getBase64ImageDataUri } from '@/services/utils/global.js';

const props = defineProps({
    tableItems: {
        type: Array,
    },
    antibioticsDrowdown: {
        type: Array,
    },
    hasGlobalMachineImage: {
      type: Boolean,
      default: false
    }
})

const { fetchNoteMasterList } = handleHospital();
const hasUnitColumn = computed(() => {
  return props.tableItems.some(
      item => item.unit !== null && item.unit !== ''
  )
})
const hasInterpretationColumn = computed(() => {
  return props.tableItems.some(item =>
      (item.investigation_report_type === 'antibiotics' &&
          item.comment !== null && item.comment !== '') ||
      (item.reference_value !== null && item.reference_value !== '')
  )
})

const hasMachineImage = computed(() => {
  return props.tableItems.some(item =>
      (item.investigation_report_type === 'machine_image' && item.result != null)
  )
})

const handleGrowthChange = (item) => {
  item.result = '';
  if (item.cs_growth && item.cs_growth.short_desc) {
    item.result = item.cs_growth.short_desc;
  }
}

</script>

<style scoped>
.name-th{
    width: 30%;
}
.result-th{
    width: 35%;
}
.machine-th{
  width: 12%;
}
</style>